import { Box, Button, Input as DeprecatedInput, Text } from '@air/zephyr';
import { Formik } from 'formik';
import { useState } from 'react';
import { object, string } from 'yup';

import { Form } from '~/old-marketing/components/Form';
import { InternalLink } from '~/old-marketing/components/Link';
import { Routes } from '~/old-marketing/constants/Routes';

const validationSchema = object({
  agencyName: string().required('Agency name is required').default(''),
  website: string().required('Agency website is required').default(''),
  email: string().email().required('Email address is required').default(''),
});

const addToSpreadsheet = async (values: { agencyName: string; website: string; email: string }) => {
  const response = await fetch('https://sheetdb.io/api/v1/u5dkolg0ozsmc', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(values),
  });

  return response.json();
};

export const AgencyForm = () => {
  const [hasSubmitted, setHasSubmitted] = useState(false);

  return (
    <Formik
      initialValues={validationSchema.cast(undefined)!}
      onSubmit={async (values) => {
        const response = await addToSpreadsheet(values);

        if (response.created === 1) {
          setHasSubmitted(true);
        }
      }}
      validationSchema={validationSchema}
    >
      <Form>
        <Box tx={{ label: { color: 'pigeon025' }, input: { border: 0 } }}>
          <DeprecatedInput
            disabled={hasSubmitted}
            label="Agency name"
            name="agencyName"
            required
            tx={{ mb: 24 }}
            variant="field-input-chonky"
          />
          <DeprecatedInput
            disabled={hasSubmitted}
            label="Website"
            name="website"
            required
            tx={{ mb: 24 }}
            type="text"
            variant="field-input-chonky"
          />
          <DeprecatedInput
            autoComplete="email"
            disabled={hasSubmitted}
            label="Email address"
            name="email"
            required
            tx={{ mb: 40 }}
            variant="field-input-chonky"
          />
          <Button
            disabled={hasSubmitted}
            size="large"
            type="submit"
            tx={{
              width: '100%',
            }}
          >
            {hasSubmitted ? 'Success!' : 'Submit'}
          </Button>
          <Text as="p" tx={{ mt: 24, color: 'white', textAlign: 'center' }} variant="text-ui-14">
            By submitting the form, you agree to our{' '}
            <InternalLink href={Routes.terms} tx={{ color: 'jay200', fontSize: 'inherit' }}>
              Terms of Service
            </InternalLink>{' '}
            and acknowledge our{' '}
            <InternalLink href={Routes.privacy} tx={{ color: 'jay200', fontSize: 'inherit' }}>
              Privacy Policy
            </InternalLink>
            .
          </Text>
        </Box>
      </Form>
    </Formik>
  );
};
